import EntriesListItem from './EntriesListItem';

export default EntriesListItem;
